import type { Organization } from '@contexts/organizations-provider';

export type NavigationKey = 'ArrowDown' | 'ArrowUp' | 'Home' | 'End';

export const LISTBOX_ID = 'org-switcher-listbox';

export function filterOrganizations(
  organizations: Organization[],
  searchQuery: string
): Organization[] {
  const trimmed = searchQuery.trim();
  if (!trimmed) return organizations;

  const query = trimmed.toLowerCase();
  return organizations.filter(org => org.name.toLowerCase().includes(query));
}

export function getNextActiveIndex(
  key: NavigationKey,
  currentIndex: number,
  itemCount: number
): number {
  if (itemCount === 0) return -1;

  switch (key) {
    case 'ArrowDown':
      return currentIndex < itemCount - 1 ? currentIndex + 1 : 0;
    case 'ArrowUp':
      return currentIndex > 0 ? currentIndex - 1 : itemCount - 1;
    case 'Home':
      return 0;
    case 'End':
      return itemCount - 1;
    default:
      return currentIndex;
  }
}

export function isNavigationKey(
  key: string
): key is 'ArrowDown' | 'ArrowUp' | 'Home' | 'End' {
  return ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(key);
}

export function getNextActiveIndexSkippingSelected(
  key: NavigationKey,
  currentIndex: number,
  itemCount: number,
  selectedIndex: number
): number {
  if (itemCount === 0) return -1;
  if (itemCount === 1 && selectedIndex === 0) return -1;

  let nextIndex = getNextActiveIndex(key, currentIndex, itemCount);

  if (nextIndex === selectedIndex) {
    if (key === 'Home') {
      nextIndex = selectedIndex === 0 ? 1 : 0;
    } else if (key === 'End') {
      nextIndex =
        selectedIndex === itemCount - 1 ? itemCount - 2 : itemCount - 1;
    } else {
      nextIndex = getNextActiveIndex(key, nextIndex, itemCount);
    }
  }

  return nextIndex;
}
